'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.encodeValue = exports.decodeValue = undefined;

var _head2 = require('ramda/src/head');

var _head3 = _interopRequireDefault(_head2);

var _experiumPlayerHelpersLegacy = require('experium-player-helpers-legacy');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var decodeValue = exports.decodeValue = function decodeValue(type, value) {
    switch (type) {
        case 'multiple':
            return value;
        case 'date':
            return (0, _head3.default)(value) ? (0, _experiumPlayerHelpersLegacy.getDecodedDateData)((0, _head3.default)(value)) : null;
        case 'month_year':
            return (0, _head3.default)(value) ? (0, _experiumPlayerHelpersLegacy.getDecodedMonthData)((0, _head3.default)(value)) : null;
        default:
            return (0, _head3.default)(value);
    }
};

var encodeValue = exports.encodeValue = function encodeValue(type, value) {
    switch (type) {
        case 'multiple':
            return value;
        case 'date':
            return (0, _experiumPlayerHelpersLegacy.getEncodedDateData)(value);
        case 'month_year':
            return (0, _experiumPlayerHelpersLegacy.getEncodedMonthData)(value);
        default:
            return value ? [value] : null;
    }
};